import _defineProperty from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _construct from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _possibleConstructorReturn from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import md5 from 'js-md5';
import JSON5 from 'json5';
import _ from 'lodash';
/* Fragment-specific assembler with custom constructor and manipulation methods. */

var FragmentAssembler =
/*#__PURE__*/
function () {
  function FragmentAssembler() {
    _classCallCheck(this, FragmentAssembler);

    this._meta = {};
  }

  _createClass(FragmentAssembler, [{
    key: "meta",
    value: function meta(key, value) {
      this._meta[key] = value;
      return this;
    }
  }]);

  return FragmentAssembler;
}();

var kNoneSpecified = Symbol();

var DagLayoutFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler) {
  _inherits(DagLayoutFragmentAssembler, _FragmentAssembler);

  function DagLayoutFragmentAssembler(flowDirection, alignChildren) {
    var _this;

    _classCallCheck(this, DagLayoutFragmentAssembler);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DagLayoutFragmentAssembler).call(this));
    _this._nodes = {};
    _this._children = {}; // Maps parent -> children.

    _this._parents = {}; // Maps children -> parents.

    _this._alignments = [];
    _this._edges = [];
    _this._items = {};
    _this._flowDirection = flowDirection;
    _this._alignChildren = alignChildren;
    return _this;
  }

  _createClass(DagLayoutFragmentAssembler, [{
    key: "node",
    value: function node(name) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var item = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : kNoneSpecified;
      if (!this._nodes[name]) this._nodes[name] = {};
      var parent = config.parent,
          alignWith = config.alignWith;

      if (parent !== undefined) {
        // If the node already had a parent, remove it from its list of children
        if (this._parents[name]) {
          var idx = this._children[this._parents[name]].indexOf(name);

          this._children[this._parents[name]].splice(idx);
        }

        if (parent === null) {
          delete this._parents[name];
        } else {
          this._parents[name] = parent;
          if (!this._children[parent]) this._children[parent] = [];

          this._children[parent].push(name);
        }
      }

      if (alignWith) {
        if (Array.isArray(alignWith)) {
          var _this$_alignments;

          (_this$_alignments = this._alignments).push.apply(_this$_alignments, _toConsumableArray(alignWith.map(function (alignment) {
            return Object.assign(Object.assign({}, alignment), {
              nodes: [name].concat(_toConsumableArray(alignment.nodes))
            });
          })));
        } else if (alignWith !== undefined) {
          this._alignments.push(Object.assign(Object.assign({}, alignWith), {
            nodes: [name].concat(_toConsumableArray(alignWith.nodes))
          }));
        }
      }

      delete config.parent;
      delete config.alignWith;

      _.merge(this._nodes[name], config);

      if (item !== kNoneSpecified) this._items[name] = item;
      return this;
    }
  }, {
    key: "port",
    value: function port(nodeName, portName, side, order) {
      var node = this._nodes[nodeName];
      if (!node.ports) node.ports = {};
      node.ports[portName] = _.merge(node.ports[portName], Object.assign(Object.assign({}, side && {
        side: side
      }), order && {
        order: order
      }));
      return this;
    }
  }, {
    key: "edge",
    value: function edge(source, target, label) {
      var edge = Object.assign({
        source: typeof source === 'string' ? {
          id: source
        } : source,
        target: typeof target === 'string' ? {
          id: target
        } : target
      }, label && {
        label: label
      });

      this._edges.push(edge);

      return this;
    }
  }, {
    key: "item",
    value: function item(nodeName) {
      var _item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kNoneSpecified;

      this._items[nodeName] = _item;
      return this;
    }
  }, {
    key: "assemble",
    value: function assemble(getId) {
      var _this2 = this;

      // Ensure all nodes have an item.
      _.keys(this._nodes).forEach(function (name) {
        if (!(name in _this2._items)) throw new Error("Node with no item: ".concat(name));
      }); // Ensure all edge start/end nodes and ports are valid.


      this._edges.forEach(function (_ref, idx) {
        var source = _ref.source,
            target = _ref.target,
            label = _ref.label;
        var sourceId = source.id,
            sourcePort = source.port;
        var targetId = target.id,
            targetPort = target.port;

        if (!(sourceId in _this2._nodes)) {
          throw new Error("Edge starts at unknown node: ".concat(sourceId));
        } else if (sourcePort) {
          var sourcePorts = _this2._nodes[sourceId].ports;

          if (!sourcePorts || !(sourcePort in sourcePorts)) {
            throw new Error("Edge starts at unknown port: ".concat(sourcePort, " (node ").concat(sourceId, ")"));
          }
        }

        if (!(targetId in _this2._nodes)) {
          throw new Error("Edge ends at unknown node: ".concat(targetId));
        } else if (targetPort) {
          var targetPorts = _this2._nodes[targetId].ports;

          if (!targetPorts || !(targetPort in targetPorts)) {
            throw new Error("Edge ends at unknown port: ".concat(targetPort, " (node ").concat(targetId, ")"));
          }
        }
      });

      return [{
        type: 'DagLayout',
        contents: {
          nodes: _.mapValues(this._nodes, function (node, name) {
            return Object.assign({
              fragmentId: getId(_this2._items[name], "n".concat(name)),
              children: _this2._children[name] || []
            }, node);
          }),
          edges: _.mapKeys(this._edges, function (edge, idx) {
            return "e".concat(idx);
          }),
          alignments: this._alignments,
          flowDirection: this._flowDirection,
          alignChildren: this._alignChildren
        },
        meta: this._meta
      }, Object.keys(this._nodes).map(function (name) {
        return _this2._items[name];
      })];
    }
  }]);

  return DagLayoutFragmentAssembler;
}(FragmentAssembler);

function Dag(flowDirection, alignChildren) {
  return new DagLayoutFragmentAssembler(flowDirection, alignChildren);
}

var FlowLayoutFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler2) {
  _inherits(FlowLayoutFragmentAssembler, _FragmentAssembler2);

  function FlowLayoutFragmentAssembler() {
    var _this3;

    _classCallCheck(this, FlowLayoutFragmentAssembler);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(FlowLayoutFragmentAssembler).call(this));

    for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) {
      elements[_key] = arguments[_key];
    }

    _this3._elements = elements;
    return _this3;
  }

  _createClass(FlowLayoutFragmentAssembler, [{
    key: "item",
    value: function item(_item2) {
      this._elements.push(_item2);

      return this;
    }
  }, {
    key: "items",
    value: function items() {
      var _this$_elements;

      (_this$_elements = this._elements).push.apply(_this$_elements, arguments);

      return this;
    }
  }, {
    key: "assemble",
    value: function assemble(getId) {
      return [{
        type: 'FlowLayout',
        contents: {
          elements: this._elements.map(function (elem, idx) {
            return getId(elem, "".concat(idx));
          })
        },
        meta: this._meta
      }, this._elements];
    }
  }]);

  return FlowLayoutFragmentAssembler;
}(FragmentAssembler);

function Flow() {
  for (var _len2 = arguments.length, elements = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    elements[_key2] = arguments[_key2];
  }

  return _construct(FlowLayoutFragmentAssembler, elements);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function withinBounds(bounds, row, col) {
  var r = bounds.r,
      c = bounds.c,
      R = bounds.R,
      C = bounds.C;
  return r <= row && row <= R && c <= col && col <= C;
}

function parseGridString(str) {
  var rows = str.split(/[\n,|]+/).map(function (row) {
    return row.replace(/\s/g, '');
  }).filter(function (row) {
    return row.length > 0;
  });

  if (!rows || !rows.every(function (row) {
    return row.length === rows[0].length;
  })) {
    throw new Error("Specification string must be rectangular, got rows: ".concat(rows));
  }

  var grid = rows.map(function (row) {
    return row.split('');
  });
  var bounds = {};

  for (var r = 0; r < grid.length; r++) {
    var _loop = function _loop(c) {
      var _char = grid[r][c];

      if (_char in bounds) {
        // A previously encountered character must be within the greedily expanded bounds.
        if (withinBounds(bounds[_char], r, c)) return "continue";
        throw new Error("Specification string malformed for cell: ".concat(_char));
      } else {
        var _ret2 = function () {
          if (_char === '.') return {
            v: "continue"
          }; // Create a new cell and greedily expand col-wise then row-wise while bounds
          // keep fencing a contiguous rectangle of `char`.

          var R = r,
              C = c;

          while (C + 1 < grid[0].length && grid[r][C + 1] === _char) {
            C++;
          }

          while (R + 1 < grid.length && _.range(c, C + 1).every(function (idx) {
            return grid[R + 1][idx] === _char;
          })) {
            R++;
          }

          bounds[_char] = {
            r: r,
            c: c,
            R: R,
            C: C
          };
        }();

        if (typeof _ret2 === "object") return _ret2.v;
      }
    };

    for (var c = 0; c < grid[0].length; c++) {
      var _ret = _loop(c);

      if (_ret === "continue") continue;
    }
  }

  return _.mapValues(bounds, function (_ref2) {
    var r = _ref2.r,
        c = _ref2.c,
        R = _ref2.R,
        C = _ref2.C;
    return {
      row: r,
      col: c,
      height: R - r + 1,
      width: C - c + 1
    };
  });
}

var kNoneSpecified$1 = Symbol();

var GridLayoutFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler3) {
  _inherits(GridLayoutFragmentAssembler, _FragmentAssembler3);

  function GridLayoutFragmentAssembler(cells, items) {
    var _this4;

    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, GridLayoutFragmentAssembler);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(GridLayoutFragmentAssembler).call(this));
    _this4._cells = {};
    _this4._items = {};

    if (cells) {
      if (typeof cells === 'string') {
        // Cells provided as specification string.
        _this4._cells = parseGridString(cells);
      } else if (Array.isArray(cells)) {
        // Cells already provided in structured format.
        cells.forEach(function (_a) {
          var name = _a.name,
              cell = __rest(_a, ["name"]);

          return _this4._cells[name] = cell;
        });
      } else {
        throw new Error("Unknown format received for cells: ".concat(cells));
      }
    }

    if (items) _this4._items = items;

    _this4.config(config);

    return _this4;
  }

  _createClass(GridLayoutFragmentAssembler, [{
    key: "cell",
    value: function cell(name, row, col, height, width) {
      var item = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : kNoneSpecified$1;
      this._cells[name] = {
        row: row,
        col: col,
        height: height,
        width: width
      };
      if (item !== kNoneSpecified$1) this._items[name] = item;
      return this;
    }
  }, {
    key: "item",
    value: function item(name, _item3) {
      this._items[name] = _item3;
      return this;
    }
  }, {
    key: "config",
    value: function config(_config) {
      var rowHeight = _config.rowHeight,
          colWidth = _config.colWidth,
          showLabels = _config.showLabels;
      if (rowHeight !== undefined) this._rowHeight = rowHeight;
      if (colWidth !== undefined) this._colWidth = colWidth;
      if (showLabels !== undefined) this._showLabels = showLabels;
      return this;
    }
  }, {
    key: "assemble",
    value: function assemble(getId) {
      var _this5 = this;

      _.keys(this._cells).forEach(function (name) {
        if (!(name in _this5._items)) throw new Error("Cell with no item: ".concat(name));
      });

      return [{
        type: 'GridLayout',
        contents: {
          cells: _.entries(this._cells).map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                name = _ref4[0],
                cell = _ref4[1];

            return Object.assign({
              fragmentId: getId(_this5._items[name], name)
            }, cell);
          }),
          rowHeight: this._rowHeight,
          colWidth: this._colWidth,
          showLabels: this._showLabels
        },
        meta: this._meta
      }, Object.keys(this._cells).map(function (name) {
        return _this5._items[name];
      })];
    }
  }]);

  return GridLayoutFragmentAssembler;
}(FragmentAssembler);
/**
 * `Grid` is a layout with slots (named cells) arranged on a 2D grid. Cells can have different
 * dimensions and can even overlap.
 * @param cells
 *     (optional) (1) A list of named cells. (2) A specification string where cells must be
 *     contiguous rectangles of the same character, and all instances of a character must be part
 *     of the same rectangle. Each row is on a different line and all other whitespace is ignored.
 *     The special character '.' is ignored.
 * @param items
 *     (optional) Items to fill slots with.
 * @example
 *     // These produce the equivalent cells.
 *     Grid([{ name: "A", row: 0, col: 0, width: 1, height: 1 },
 *           { name: "B", row: 0, col: 1, width: 3, height: 1 }])
 *     Grid(`A BBB`)
 *     Grid(`A B B B`)
 *
 *     // Use multi-line strings to create rows.
 *     Grid(`A BB C
 *           D BB E`)
 */


function Grid(cells, items) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new GridLayoutFragmentAssembler(cells, items, config);
} // TODO: Allow width of grid to be set independently (e.g. so that ". A B ." case works).


var IconPrimitiveFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler4) {
  _inherits(IconPrimitiveFragmentAssembler, _FragmentAssembler4);

  function IconPrimitiveFragmentAssembler(name, emphasis) {
    var _this6;

    _classCallCheck(this, IconPrimitiveFragmentAssembler);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(IconPrimitiveFragmentAssembler).call(this));
    _this6._name = name;
    _this6._emphasis = emphasis;
    return _this6;
  }

  _createClass(IconPrimitiveFragmentAssembler, [{
    key: "assemble",
    value: function assemble(getId) {
      return [{
        type: 'IconPrimitive',
        contents: {
          name: this._name,
          emphasis: this._emphasis
        },
        meta: this._meta
      }, []];
    }
  }]);

  return IconPrimitiveFragmentAssembler;
}(FragmentAssembler);

function Icon(name, emphasis) {
  return new IconPrimitiveFragmentAssembler(name, emphasis);
}

var ImagePrimitiveFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler5) {
  _inherits(ImagePrimitiveFragmentAssembler, _FragmentAssembler5);

  function ImagePrimitiveFragmentAssembler(location) {
    var _this7;

    _classCallCheck(this, ImagePrimitiveFragmentAssembler);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(ImagePrimitiveFragmentAssembler).call(this));
    _this7._location = location;
    return _this7;
  }

  _createClass(ImagePrimitiveFragmentAssembler, [{
    key: "assemble",
    value: function assemble(getId) {
      return [{
        type: 'ImagePrimitive',
        contents: {
          location: this._location
        },
        meta: this._meta
      }, []];
    }
  }]);

  return ImagePrimitiveFragmentAssembler;
}(FragmentAssembler);

function Image(location) {
  return new ImagePrimitiveFragmentAssembler(location);
}

var KeyValueLayoutFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler6) {
  _inherits(KeyValueLayoutFragmentAssembler, _FragmentAssembler6);

  function KeyValueLayoutFragmentAssembler(entries) {
    var _this8;

    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, KeyValueLayoutFragmentAssembler);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(KeyValueLayoutFragmentAssembler).call(this));
    _this8._entries = [];
    if (entries) _this8._entries = entries;

    _this8.config(config);

    return _this8;
  }

  _createClass(KeyValueLayoutFragmentAssembler, [{
    key: "item",
    value: function item(key, value) {
      this._entries.push([key, value]);

      return this;
    }
  }, {
    key: "config",
    value: function config(_config2) {
      var separator = _config2.separator,
          startMotif = _config2.startMotif,
          endMotif = _config2.endMotif,
          alignSeparators = _config2.alignSeparators,
          showLabels = _config2.showLabels;
      if (separator !== undefined) this._separator = separator;
      if (startMotif !== undefined) this._startMotif = startMotif;
      if (endMotif !== undefined) this._endMotif = endMotif;
      if (alignSeparators !== undefined) this._alignSeparators = alignSeparators;
      if (showLabels !== undefined) this._showLabels = showLabels;
      return this;
    }
  }, {
    key: "assemble",
    value: function assemble(getId) {
      return [{
        type: 'KeyValueLayout',
        contents: {
          entries: this._entries.map(function (_ref5, idx) {
            var _ref6 = _slicedToArray(_ref5, 2),
                key = _ref6[0],
                value = _ref6[1];

            return {
              key: getId(key, "".concat(idx, "k")),
              value: getId(value, "".concat(idx, "v"))
            };
          }),
          separator: this._separator,
          startMotif: this._startMotif,
          endMotif: this._endMotif,
          alignSeparators: this._alignSeparators,
          showLabels: this._showLabels
        },
        meta: this._meta
      }, _.flatMap(this._entries, function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            value = _ref8[1];

        return [key, value];
      })];
    }
  }]);

  return KeyValueLayoutFragmentAssembler;
}(FragmentAssembler);

function KeyValue(entries) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new KeyValueLayoutFragmentAssembler(entries, config);
}

var SequenceLayoutFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler7) {
  _inherits(SequenceLayoutFragmentAssembler, _FragmentAssembler7);

  function SequenceLayoutFragmentAssembler(elements) {
    var _this9;

    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SequenceLayoutFragmentAssembler);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(SequenceLayoutFragmentAssembler).call(this));
    _this9._elements = [];
    if (elements) _this9._elements = elements;

    _this9.config(config);

    return _this9;
  }

  _createClass(SequenceLayoutFragmentAssembler, [{
    key: "item",
    value: function item(_item4) {
      this._elements.push(_item4);

      return this;
    }
  }, {
    key: "items",
    value: function items() {
      var _this$_elements2;

      (_this$_elements2 = this._elements).push.apply(_this$_elements2, arguments);

      return this;
    }
  }, {
    key: "config",
    value: function config(_config3) {
      var orientation = _config3.orientation,
          startMotif = _config3.startMotif,
          endMotif = _config3.endMotif,
          showLabels = _config3.showLabels;
      if (orientation !== undefined) this._orientation = orientation;
      if (startMotif !== undefined) this._startMotif = startMotif;
      if (endMotif !== undefined) this._endMotif = endMotif;
      if (showLabels !== undefined) this._showLabels = showLabels;
      return this;
    }
  }, {
    key: "assemble",
    value: function assemble(getId) {
      return [{
        type: 'SequenceLayout',
        contents: {
          elements: this._elements.map(function (elem, idx) {
            return getId(elem, "".concat(idx));
          }),
          orientation: this._orientation,
          startMotif: this._startMotif,
          endMotif: this._endMotif,
          showLabels: this._showLabels
        },
        meta: this._meta
      }, this._elements];
    }
  }]);

  return SequenceLayoutFragmentAssembler;
}(FragmentAssembler);

function Sequence(elements) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new SequenceLayoutFragmentAssembler(elements, config);
}

var kNoneSpecified$2 = Symbol();

var SwitchLayoutFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler8) {
  _inherits(SwitchLayoutFragmentAssembler, _FragmentAssembler8);

  function SwitchLayoutFragmentAssembler(modes, items) {
    var _this10;

    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, SwitchLayoutFragmentAssembler);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(SwitchLayoutFragmentAssembler).call(this));
    _this10._modes = [];
    _this10._items = {};
    if (modes) _this10._modes = modes;
    if (items) _this10._items = items;

    _this10.config(config);

    return _this10;
  }

  _createClass(SwitchLayoutFragmentAssembler, [{
    key: "mode",
    value: function mode(name) {
      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kNoneSpecified$2;

      this._modes.push(name);

      if (item !== kNoneSpecified$2) this._items[name] = item;
      return this;
    }
  }, {
    key: "item",
    value: function item(name, _item5) {
      this._items[name] = _item5;
      return this;
    }
  }, {
    key: "config",
    value: function config(_config4) {
      var showLabels = _config4.showLabels;
      if (showLabels !== undefined) this._showLabels = showLabels;
      return this;
    }
  }, {
    key: "assemble",
    value: function assemble(getId) {
      var _this11 = this;

      this._modes.forEach(function (name) {
        if (!(name in _this11._items)) throw new Error("Mode with no item: ".concat(name));
      });

      return [{
        type: 'SwitchLayout',
        contents: {
          modes: this._modes.map(function (name) {
            return getId(_this11._items[name], "".concat(name));
          }),
          showLabels: this._showLabels
        },
        meta: this._meta
      }, this._modes.map(function (name) {
        return _this11._items[name];
      })];
    }
  }]);

  return SwitchLayoutFragmentAssembler;
}(FragmentAssembler);

function Switch(modes, items) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new SwitchLayoutFragmentAssembler(modes, items, config);
}

var TextPrimitiveFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler9) {
  _inherits(TextPrimitiveFragmentAssembler, _FragmentAssembler9);

  function TextPrimitiveFragmentAssembler(text, variant, emphasis) {
    var _this12;

    _classCallCheck(this, TextPrimitiveFragmentAssembler);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(TextPrimitiveFragmentAssembler).call(this));
    _this12._text = text;
    _this12._variant = variant;
    _this12._emphasis = emphasis;
    return _this12;
  }

  _createClass(TextPrimitiveFragmentAssembler, [{
    key: "assemble",
    value: function assemble(getId) {
      return [{
        type: 'TextPrimitive',
        contents: {
          text: this._text,
          variant: this._variant,
          emphasis: this._emphasis
        },
        meta: this._meta
      }, []];
    }
  }]);

  return TextPrimitiveFragmentAssembler;
}(FragmentAssembler);

function Text(text, variant, emphasis) {
  return new TextPrimitiveFragmentAssembler(text, variant, emphasis);
}

var TokenPrimitiveFragmentAssembler =
/*#__PURE__*/
function (_FragmentAssembler10) {
  _inherits(TokenPrimitiveFragmentAssembler, _FragmentAssembler10);

  function TokenPrimitiveFragmentAssembler(text, color) {
    var _this13;

    _classCallCheck(this, TokenPrimitiveFragmentAssembler);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(TokenPrimitiveFragmentAssembler).call(this));
    _this13._text = text;
    _this13._color = color;
    return _this13;
  }

  _createClass(TokenPrimitiveFragmentAssembler, [{
    key: "assemble",
    value: function assemble(getId) {
      return [{
        type: 'TokenPrimitive',
        contents: {
          text: this._text,
          color: this._color
        },
        meta: this._meta
      }, []];
    }
  }]);

  return TokenPrimitiveFragmentAssembler;
}(FragmentAssembler);

function Token(text, color) {
  return new TokenPrimitiveFragmentAssembler(text, color);
}

var kMinShownLength = 10;

function getLanguageDefault(obj) {
  if (obj !== Object(obj)) {
    // Primitive like number, string, or symbol.
    return Token(typeof obj === 'string' ? "\"".concat(obj, "\"") : "".concat(obj));
  } else if (Array.isArray(obj)) {
    return Sequence(obj, {
      orientation: 'horizontal',
      startMotif: "".concat(obj.length < kMinShownLength ? '' : "[".concat(obj.length, "] "), "["),
      endMotif: ']'
    });
  } else if (obj instanceof Set) {
    return Sequence(Array.from(obj), {
      orientation: 'horizontal',
      startMotif: "".concat(obj.size < kMinShownLength ? '' : "[".concat(obj.size, "] "), "{"),
      endMotif: '}'
    });
  } else if (obj instanceof Map) {
    return KeyValue(Array.from(obj.entries()), {
      startMotif: "".concat(obj.size < kMinShownLength ? '' : "[".concat(obj.size, "] "), "{"),
      endMotif: '}'
    });
  } else if (typeof obj === 'function') {
    var _getFunctionArgs = getFunctionArgs(obj),
        args = _getFunctionArgs.args,
        defaults = _getFunctionArgs.defaults;

    return KeyValue(args.map(function (arg, idx) {
      return [arg, defaults[idx]];
    }), {
      startMotif: obj.name ? "".concat(obj.name, " (") : "Function (",
      endMotif: ')'
    });
  } else {
    return KeyValue(Object.entries(obj), {
      startMotif: "".concat(Object.keys(obj).length < kMinShownLength ? '' : "[".concat(Object.keys(obj).length, "] "), "{"),
      endMotif: '}'
    });
  }
}

function getFunctionArgs(func) {
  var params = (func + '').replace(/[/][/].*$/gm, '') // strip single-line comments
  .replace(/\s+/g, '') // strip white space
  .replace(/[/][*][^/*]*[*][/]/g, '') // strip multi-line comments
  .split('){', 1)[0].split(')=>')[0].replace(/^[^(]*[(]/, '') // extract the parameters

  /* .replace(/=[^,]+/g, '') // strip any ES6 defaults */
  .split(',').filter(Boolean); // split & filter [""]

  return {
    args: params.map(function (param) {
      return param.split('=')[0];
    }),
    defaults: params.map(function (param) {
      var value = param.split('=').length > 1 ? param.split('=')[1] : undefined;

      try {
        if (value) {
          value = JSON5.parse(value);
        }
      } catch (error) {}

      return value;
    })
  };
}
/**
 * While it is possible to manually assemble `View`/`Fragment` data structures to feed to a
 * `Viewer`, it is often much more convenient to use "Assemblers". These are lightweight helper
 * classes that allow a developer to declaratively and incrementally assemble the data structures
 * using a chain syntax.
 *
 * Each programming language can have its own set of bindings for the "Assemblers". This allows
 * developers to construct `View`/`Fragment` data structures from a variety of backends, enabling a
 * shared interface for visualizing data in different program contexts and platforms. Each
 * language's bindings can define its own language-specific defaults for how to convert native
 * constructs into visualizations. Additionally, developers can create custom views for different
 * classes by implementing custom view methods (e.g. `__view__()`).
 */

/* Converts the given object into a `View`. The object can be a `FragmentAssembler`, a native
 * language construct (e.g. int, list, class, function), or objects with custom view methods.
 * In nested objects (e.g. list, set, map), it is possible to mix these types. */


var ViewAssembler =
/*#__PURE__*/
function () {
  /**
   * Constructor.
   * @param getFragmentId
   *     Function to produce a FragmentId for an object given its name and its parent's ID.
   */
  function ViewAssembler(getFragmentId) {
    _classCallCheck(this, ViewAssembler);

    if (getFragmentId) {
      this._getFragmentId = getFragmentId;
    }
  }

  _createClass(ViewAssembler, [{
    key: "_getFragmentAssembler",
    value: function _getFragmentAssembler(obj) {
      if (obj instanceof FragmentAssembler) {
        return obj;
      } else if (obj === Object(obj) && '__view__' in obj) {
        return obj.__view__();
      } else {
        return getLanguageDefault(obj);
      }
    }
  }, {
    key: "_getFragmentId",
    value: function _getFragmentId(name, parentId) {
      return md5.base64("".concat(parentId, "-").concat(name)).slice(0, 10);
    }
    /**
     * @param obj
     * @return
     *     `View` data structure that represents the given `obj`.
     */

  }, {
    key: "assemble",
    value: function assemble(obj) {
      var _this14 = this;

      // An object is "assigned" a `FragmentId` when it is encountered for the first time, but
      // the corresponding `Fragment` object is `null` until the object has been taken off the
      // the queue and processed. This must be the case since the children of an object are
      // processed later than it and since an object may reference itself.
      var rootId = ViewAssembler._kRootId;
      var assigned = new Map([[obj, rootId]]);

      var fragments = _defineProperty({}, rootId, null);

      var queue = [obj];

      var _loop2 = function _loop2() {
        var curr = queue.shift();
        var fragId = assigned.get(curr);
        if (!fragId) throw new Error("Object returned as ref was not assigned a FragmentId: ".concat(JSON.stringify(curr))); // Already processed current object.

        if (fragments[fragId] !== null) return "continue"; // Process current object and append list of refs to to the queue.

        var fasm = _this14._getFragmentAssembler(curr);

        var _fasm$assemble = fasm.assemble(function (obj, name) {
          var existingId = assigned.get(obj);
          if (existingId) return existingId;

          var createdId = _this14._getFragmentId(name, fragId);

          assigned.set(obj, createdId);
          fragments[createdId] = null;
          return createdId;
        }),
            _fasm$assemble2 = _slicedToArray(_fasm$assemble, 2),
            frag = _fasm$assemble2[0],
            refs = _fasm$assemble2[1];

        fragments[fragId] = frag;
        queue.push.apply(queue, _toConsumableArray(refs));
      };

      while (queue.length > 0) {
        var _ret3 = _loop2();

        if (_ret3 === "continue") continue;
      }

      Object.entries(fragments).forEach(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            id = _ref10[0],
            frag = _ref10[1];

        if (!frag) throw new Error("Object assigned a FragmentId was not returned as a ref: ".concat(id));
      });
      return {
        rootId: rootId,
        fragments: fragments
      };
    }
  }]);

  return ViewAssembler;
}();
/* Default ID for root fragment.*/


ViewAssembler._kRootId = 'root';

function assemble(obj, getFragmentId) {
  return new ViewAssembler(getFragmentId).assemble(obj);
}

export { Dag, Flow, FragmentAssembler, Grid, Icon, Image, KeyValue, Sequence, Switch, Text, Token, assemble };